var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Zone")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubzoneid),
      expression: "hubzoneid"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "hubzoneid",
      "id": "hubzoneid"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubzoneid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changezone($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(" -- Select -- ")]), _vm._v(" "), _vm._l((_vm.hubZoneList), function(hubZones) {
    return _c('option', {
      domProps: {
        "value": {
          id: hubZones.hubzoneid,
          text: hubZones.hubzonename
        }
      }
    }, [_vm._v(_vm._s(hubZones.hubzonename))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Name")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.hubList,
      "selected-option": _vm.hubIDobj,
      "name": "SR",
      "placeholder": " -- Select -- "
    },
    on: {
      "select": _vm.selectHub
    },
    model: {
      value: (_vm.scanTallyHubID),
      callback: function($$v) {
        _vm.scanTallyHubID = $$v
      },
      expression: "scanTallyHubID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Batch Type")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.batchType),
      expression: "batchType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "batchType",
      "id": "batchType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.batchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ScanTally"
    }
  }, [_vm._v("Scan Tally")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Audit"
    }
  }, [_vm._v("Audit")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Scan Date")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanDate),
      expression: "scanDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('scanDate')
    },
    attrs: {
      "id": "scanDate",
      "type": "Date",
      "name": "scanDate",
      "placeholder": "Enter Scan Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.scanDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scanDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.tableLoading
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("Show")]), _vm._v("      \n          "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar pointerHover",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-undo",
    on: {
      "click": _vm.clear
    }
  }), _vm._v(" Reset")]), _vm._v("      \n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.reportData.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.exportAllData('rawValue', 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Export")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('vue-element-loading', {
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.tableLoading
    },
    on: {
      "update:active": function($event) {
        _vm.tableLoading = $event
      }
    }
  })], 1)])])])]), _vm._v(" "), (_vm.reportData.length != 0) ? _c('div', {
    staticClass: "Scantally-Report"
  }, [_c('b-card', [_c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.ShipmentDetailsLoading,
      "text": "Please wait data is being downloading.!"
    },
    on: {
      "update:active": function($event) {
        _vm.ShipmentDetailsLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "batches table-bordered table-hover tbl datatables",
    attrs: {
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_c('thead', {
    staticClass: "thead"
  }, [_c('tr', [_c('th', [_vm._v("Hub Zone Name")]), _vm._v(" "), _c('th', [_vm._v("Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Batch ID")]), _vm._v(" "), _c('th', [_vm._v("Batch Type")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Total Scantally Eligible")]), _vm._v(" "), _c('th', [_vm._v("Total Scanned")]), _vm._v(" "), _c('th', [_vm._v("Pending Scantally")]), _vm._v(" "), _c('th', [_vm._v("Overage")]), _vm._v(" "), _c('th', [_vm._v("Shortage")]), _vm._v(" "), _c('th', [_vm._v("RAD Shipments")]), _vm._v(" "), _c('th', [_vm._v("OFD/Status Pending")]), _vm._v(" "), _c('th', [_vm._v("NDR")]), _vm._v(" "), _c('th', [_vm._v("Lost Notified")]), _vm._v(" "), _c('th', [_vm._v("Damaged")]), _vm._v(" "), _c('th', [_vm._v("Snatched")]), _vm._v(" "), _c('th', [_vm._v("Delivered")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reportData), function(val) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(val.HubZoneName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.HubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.BatchID) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.BatchType) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.TotalShipments))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.TotalScanShipments))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.downloadBatch(val.PendingScanTally, val.BatchID, 'PendingInScan', val.HubID)
        }
      }
    }, [_vm._v(" " + _vm._s(val.PendingScanTally))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.totalOverageShipments))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.totalShortage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.totalRADShipments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.TotalOFDShipments))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.downloadBatch(val.totalNDRShipments, val.BatchID, 'totalNDRShipments', val.HubID)
        }
      }
    }, [_vm._v(" " + _vm._s(val.totalNDRShipments))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.totalLostShipments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.totalDamageShipments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.totalSnatchedShipments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.totalDeliveredShipments))])])
  }), 0)])], 1)])], 1) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('legend', [_vm._v("Shipment Scan Tally Report")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-036f3a9b","hasScoped":true}!./src/views/components/ScanTally/ShipmentScanTallyReport/ShipmentScanTallyReport.component.html
// module id = 1133
// module chunks = 1